interface IRenewalsTableData {
  customer: string;
  customerLastName: string;
  renewalChangeAmount: string;
  renewalChangePercentage: string;
  effective: string;
  policyNumber: string;
  product: string;
}

interface IRenewalsDocumentCustomer {
  insuredName: string;
  firstName: string;
  lastName: string;
}

interface IRenewalsDocument {
  customers: IRenewalsDocumentCustomer[];
  termPolicyEffectiveDate: string;
  policyNumber: string;
  product: string;
  transactionType: string;
  totalRenewalPremium: number;
  previousTermTotalPremium: number;
  percentChangeInPremium: string;
}

export enum SortDirection {
  ascending = 'ascending',
  descending = 'descending',
  none = 'none',
}

export enum RenewalsSortableKeys {
  renewalChangePercentage = 'renewalChangePercentage',
  product = 'product',
  customer = 'customer',
  customerLastName = 'customerLastName',
  effective = 'effective',
}

interface SortDirections {
  [RenewalsSortableKeys.renewalChangePercentage]: SortDirection;
  [RenewalsSortableKeys.product]: SortDirection;
  [RenewalsSortableKeys.customer]: SortDirection;
  [RenewalsSortableKeys.customerLastName]: SortDirection;
  [RenewalsSortableKeys.effective]: SortDirection;
}

export type { IRenewalsTableData, IRenewalsDocument, IRenewalsDocumentCustomer, SortDirections };
